<p-toast></p-toast>
<div #divClick (click)="appMain.toggleMenu($event)"></div>

<div class="p-fluid p-formgrid justify-content-center top-header" style="display: flex; flex-wrap:wrap">
    <!-- <p>Dashboard & Consolidated Report Portal 2.0 <span [ngStyle]="{'color': yearHeaderColor, 'background-color': 'white'}">(FY: {{yearHeadertext}})</span><span *ngIf="yearHeadertext != '2022-23 Onwards'" class="cursor-pointer" (click)="onClearFinYear()">Clear Fin year</span></p> -->
    <p>Dashboard & Consolidated Report Portal 2.0 <span [ngStyle]="{'color': yearHeaderColor, 'background-color': 'white'}">(FY: {{yearHeadertext}})</span></p>
</div>

<!-- <div *ngIf="showDashboard"> -->
<div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
    <div *ngIf="cao || admin" class="field md:col-4 col-12">
        <div class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Total
                    Applications' }}</label>
            </div>
            <p-chart #pieChart type="doughnut" [data]="pieChartData" [options]="options" width="250" height="250"
                (onDataSelect)="onPieChartClick($event)"></p-chart>
        </div>
    </div>

    <div *ngIf="cao || admin || dmicada" class="field md:col-4 col-12">
        <div class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': '#558B2F', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Micro Irrigation Year Wise Total
                    Applications' }}</label>
            </div>
            <p-chart #pieChart type="doughnut" [data]="miDoughnutYearWiseData" [options]="options" width="250" height="250"
                (onDataSelect)="onPieMIYearWiseChartClick($event)"></p-chart>
            <div *ngIf="yearHeadertext != '2022-23 Onwards' && filterTypeName == 'MI'" class="my-2 filter-card">
                <p>{{ 'Selected Fin Year: ' }}{{ yearHeadertext }} <span *ngIf="yearHeadertext != '2022-23 Onwards'" class="cursor-pointer" (click)="onClearFinYear('MI')">Clear Year Filter</span></p>
            </div>
        </div>
    </div>

    <div *ngIf="cao || admin || dd_ew" class="field md:col-4 col-12">
        <div class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': '#202876', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Pond/ Tank Year Wise Total
                    Applications' }}</label>
            </div>
            <p-chart #pieChart type="doughnut" [data]="pondDoughnutYearWiseData" [options]="options" width="250" height="250"
                (onDataSelect)="onPiePondYearWiseChartClick($event)"></p-chart>
            <div *ngIf="yearHeadertext != '2022-23 Onwards' && filterTypeName == 'Pond'" class="my-2 filter-card">
                <p>{{ 'Selected Fin Year: ' }}{{ yearHeadertext }} <span *ngIf="yearHeadertext != '2022-23 Onwards'" class="cursor-pointer" (click)="onClearFinYear('Pond')">Clear Year Filter</span></p>
            </div>
        </div>
    </div>

    <!-- <div class="field md:col-4 col-12">
        <div *ngIf="pieChartOptions" class="pie-border">
            <div>
                <canvasjs-chart [options]="pieChartOptions" [styles]="{width: 'auto', height:'250px'}"></canvasjs-chart>    
            </div>        
        </div>
    </div> -->
    <div *ngIf="miBifurcatedData && dmicada" class="field md:col-4 col-12">
        <div *ngIf="miBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center mb-2" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Micro Irrigation
                    (PDMC Scheme) Progress' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="miBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onMIChartClick($event)"></p-chart>
        </div>
    </div>
    <div *ngIf="dmicada" class="field md:col-4 col-12">    
        <div class="statedata">
            <div class="field md:col-3 col-6" style="width: 100%;" >
                <div class="box clickable" >
                    <div class="total">{{ 'Subsidy Disbursed (₹): '}}</div>
                    <div class="count">{{ totalSubsidyDisbursed | number}} &nbsp;Cr. </div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="width: 100%;" >
                <div class="box clickable" >
                    <div class="total">{{ 'No of Beneficiaries:'}}</div>
                    <div class="count">{{ totalAppCompleted | number}}  </div>
                </div>
            </div>
            <div class="field md:col-3 col-6" style="width: 100%;">
                <div class="box clickable" >
                    <div class="total">{{ 'Total Benefited Area: '}}</div>
                    <div class="count">{{ totalMIAreaCompleted | number}} &nbsp;Acre. </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="pondBifurcatedData && dd_ew" class="field md:col-6 col-12">
        <div *ngIf="pondBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                    'Pond/Tank' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="pondBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onPondChartClick($event)"></p-chart>
        </div>
    </div>

    <!-- <div *ngIf="miBifurcatedData && (cao || admin) && showOnlyMI" class="p-fluid p-formgrid justify-content-center sub-header" style="display: flex; flex-wrap:wrap">
        <p> MI </p>
    </div>
    <div *ngIf="pondBifurcatedData && (cao || admin) && showOnlyPond" class="p-fluid p-formgrid justify-content-center sub-header" style="display: flex; flex-wrap:wrap">
        <p> Pond/ Tank </p>
    </div> -->
    
    <div *ngIf="miBifurcatedData && (cao || admin) && !showOnlyPond && !showOnlyMI" class="field md:col-6 col-12">
        <div *ngIf="miBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center mb-2" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Micro Irrigation
                    (PDMC Scheme) Progress' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="miBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onMIChartClick($event)"></p-chart>
        </div>
    </div>
    <div *ngIf="miBifurcatedData && (cao || admin) && showOnlyMI" class="field md:col-12 col-12">
        <div *ngIf="miBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center mb-2" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Micro Irrigation
                    (PDMC Scheme) Progress' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="miBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onMIChartClick($event)"></p-chart>
        </div>
    </div>
    <div *ngIf="pondBifurcatedData && (cao || admin) && !showOnlyPond && !showOnlyMI" class="field md:col-6 col-12">
        <div *ngIf="pondBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                    'Pond/Tank' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="pondBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onPondChartClick($event)"></p-chart>
        </div>
    </div>
    <div *ngIf="pondBifurcatedData && (cao || admin) && showOnlyPond" class="field md:col-12 col-12">
        <div *ngIf="pondBifurcatedData" class="pie-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                    'Pond/Tank' }}</label>
            </div>

            <p-chart #barChart type="bar" [data]="pondBifurcatedData" [options]="options1" width="250" height="250"
                (onDataSelect)="onPondChartClick($event)"></p-chart>
        </div>
    </div>
</div>

<div *ngIf="showMIDistrciData" class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
    <div *ngIf="(cao || admin)" class="field md:col-12 col-12">
        <!-- <div class="statedata">
            <ul>
                <li style="background-color: #77eba5">
                    <strong><i class="fa fa-inr" aria-hidden="true"></i> Total Subsidy Disbursed: </strong>
                    <span class="counter" data-count="totalSubsidyDisbursed">{{ totalSubsidyDisbursed }}</span>
                </li>
                <li style="background-color: #77eba5">
                    <strong><i class="fa fa-bar-chart" aria-hidden="true"></i> Total Application Completed: </strong>
                    <span class="counter" data-count="totalAppCompleted">{{ totalAppCompleted }}</span>
                </li>
                <li style="background-color: #77eba5">
                    <strong><i class="fa fa-bars" aria-hidden="true"></i> Total MI Area Completed: </strong>
                    <span class="counter" data-count="totalMIAreaCompleted">{{ totalMIAreaCompleted }}</span> Acr.
                </li>
            </ul>
        </div> -->

        <div class="statedata">
            <ul>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-inr" aria-hidden="true"></i> {{ 'Subsidy Disbursed (₹): '}} &nbsp;</strong>
                    <span class="counter">{{ totalSubsidyDisbursed | number }}</span> &nbsp;Cr.
                </li>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bar-chart" aria-hidden="true"></i>{{ 'Application Completed: '}} &nbsp;</strong>
                    <span class="counter">{{ totalAppCompleted | number }}</span>
                </li>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bars" aria-hidden="true"></i>{{ 'MI Area Completed: '}} &nbsp;</strong>
                    <span class="counter">{{ totalMIAreaCompleted | number }}</span> &nbsp;Acr.
                </li>
            </ul>
        </div>
    </div>
    <div class="field md:col-12 col-12">
        <div *ngIf="miDistrictWiseDataForChart" class="district-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                    'MI(PDMC) Disctrict Wise Total App & Area' }}</label>
                <label [style]="{'color': 'blue', 'font-size': '0.7rem', 'font-weight': 'bold', 'margin-top': '5px', 'margin-left': '20px'}"> {{ 'Click here:  ' }} <span [style]="{cursor: 'pointer'}" (click)="viewMIConsolidatedReport()">{{'Consolidated Abstract/ '}}</span><span [style]="{cursor: 'pointer'}" (click)="viewMIConsolidatedDetails()">{{'Consolidated Details'}}</span></label>
            </div>
            <p-chart #barChart type="bar" [data]="miDistrictWiseDataForChart" [options]="optionsMIDW" width="auto"
                min-height="280px" (onDataSelect)="onDistrictChartClick($event)"></p-chart>
        </div>
    </div>
</div>
<div #miDistrictWiseDataCard *ngIf="miDistrictWiseDashboardData" class="district-wise-data">
    <p [style]="{'color': '#388585', 'font-size': '1.2rem', 'font-weight': 'bold'}">{{ districtWiseHeader }}</p>

    <!-- <div class="row home-stats">
        <div class="statedata">
          <ul>
            <li style="background-color: #B5EAEA"><strong><i class="fa fa-inr" aria-hidden="true"></i>
                Total Subsidy Disbursed: </strong><span class="counter" data-count="1839780">18,397,80</span> Cr.</li>
            <li style="background-color: #EDF6E5"><strong><i class="fa fa-bar-chart" aria-hidden="true"></i>
                Farmers Registered: </strong><span class="counter" data-count="966468">966,468</span></li>
            <li style="background-color: #F4DFD0"><strong><i class="fa fa-bars" aria-hidden="true"></i>
                Total MI Area: </strong><span class="counter" data-count="230107">230,107</span> Acr.</li>
          </ul>
        </div>
    </div> -->

    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div *ngIf="miDistrictWiseDashboarSchemedData.length > 0" class="field md:col-12 col-12">
            <div class="district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'MI(PDMC) Scheme Wise Total App'
                        }}</label>
                </div>
                <p-chart #barChart type="bar" [data]="miDistrictWiseSchemeDataForGraph" [options]="optionsMIScheme" width="auto"
                    min-height="280px"></p-chart>
            </div>
        </div>
        <div *ngIf="subsidyDataForChart" class="field md:col-3 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy Count'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="subsidyDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <!-- <div class="field md:col-3 col-12">
            <div *ngIf="subsidyAreaDataForChart" class="pie-district-border">
                <div class="row home-stats">
                    <div class="statedata">
                      <ul>
                        <li style="background-color: #B5EAEA"><strong><i class="fa fa-inr" aria-hidden="true"></i>
                            Total Subsidy Disbursed: </strong><span class="counter" data-count="1839780">18,397,80</span> Cr.</li>
                        <li style="background-color: #EDF6E5"><strong><i class="fa fa-bar-chart" aria-hidden="true"></i>
                            Farmers Registered: </strong><span class="counter" data-count="966468">966,468</span></li>
                        <li style="background-color: #F4DFD0"><strong><i class="fa fa-bars" aria-hidden="true"></i>
                            Total MI Area: </strong><span class="counter" data-count="230107">230,107</span> Acr.</li>
                      </ul>
                    </div>
                </div>
            </div>
        </div> -->
        <div *ngIf="subsidyAreaDataForChart" class="field md:col-3 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy Area'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="subsidyAreaDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <!-- <div class="field md:col-3 col-12">
            <div *ngIf="subsidyAmountDataForChart" class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Subsidy Amount (in Rs.)'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="subsidyAmountDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div> -->
        <div *ngIf="yearWiseDataForChart" class="field md:col-6 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Year Wise Total MI Area (acres)'
                        }}</label>
                </div>
                <p-chart #pieChart type="line" [data]="yearWiseDataForChart" [options]="optionsLine" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <div *ngIf="casteDataForChart" class="field md:col-4 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Caste/Category Wise'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="casteDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <div *ngIf="appTypeDataForChart" class="field md:col-4 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Application Type'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="appTypeDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <div *ngIf="componentDataForChart" class="field md:col-4 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Component Wise'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="componentDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>

    </div>
</div>


<div *ngIf="showPONDDistrciData" class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
    <div class="field md:col-12 col-12">
        <div class="statedata">
            <ul>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-inr" aria-hidden="true"></i> {{ 'Stage-I Subsidy Disbursed (₹): '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalSubsidyDisbursedPond1STage | number: "1.2-2" }}&nbsp;Cr.</span>
            
                    <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bar-chart" aria-hidden="true"></i>{{ 'Stage-I Completed No.: '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalAppCompletedPond1STage | number }}</span>
                </li>
                <!-- <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bars" aria-hidden="true"></i>{{ 'Stage-I Area Compt.: '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalAreaCompletedPond1STage | number }}&nbsp;Acr.</span>
                </li> -->
            </ul>
        </div>

        <div class="statedata">
            <ul>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-inr" aria-hidden="true"></i> {{ 'Stage-II Subsidy Disbursed (₹): '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalSubsidyDisbursedPond2STage | number: "1.2-2" }}&nbsp;Cr.</span>
                </li>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bar-chart" aria-hidden="true"></i>{{ 'Stage-II Completed No.: '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalAppCompletedPond2STage | number }}</span>
                </li>
                <!-- <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bars" aria-hidden="true"></i>{{ 'Stage-II Area Compt.: '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalAreaCompletedPond2STage | number }}&nbsp;Acr.</span>
                </li> -->
            </ul>
        </div>

        <div class="statedata">
            <ul>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-inr" aria-hidden="true"></i> {{ 'Stage-III Subsidy Disbursed (₹): '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalSubsidyDisbursedPond3STage | number: "1.2-2" }}&nbsp;Cr.</span>
                </li>
                <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bar-chart" aria-hidden="true"></i>{{ 'Stage-III Completed No.: '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalAppCompletedPond3STage | number }}</span>
                </li>
                <!-- <li style="background-color: #aaefc6">
                    <strong><i class="fa fa-bars" aria-hidden="true"></i>{{ 'Stage-III Area Compt. '}} &nbsp;</strong>
                    <span [style]="{color: 'rgb(216, 20, 20)'}" class="counter">{{ totalAreaCompletedPond3STage | number }} &nbsp;Acr.</span>
                </li> -->
            </ul>
        </div>
    </div>
    <div class="field md:col-12 col-12">
        <div *ngIf="pondDistrictWiseDataForChart" class="district-border">
            <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                <label [style]="{'color': 'rgb(168, 32, 32)', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{
                    'Pond/Tank Disctrict Wise Total App & Area' }}</label>
                <label [style]="{'color': 'blue', 'font-size': '0.7rem', 'font-weight': 'bold', 'margin-top': '5px', 'margin-left': '20px'}"> {{ 'Click here:  ' }} <span [style]="{cursor: 'pointer'}" (click)="viewPondConsolidatedReport()">{{'Consolidated Abstract/ '}}</span><span [style]="{cursor: 'pointer'}" (click)="viewPondConsolidatedDetails()">{{'Consolidated Details'}}</span></label> 
            </div>
            <p-chart #barChart type="bar" [data]="pondDistrictWiseDataForChart" [options]="optionsPondDW" width="auto"
                min-height="280px" (onDataSelect)="onPondDistrictChartClick($event)"></p-chart>
        </div>
    </div>
</div>
<div #pondDistrictWiseDataCard *ngIf="pondDistrictWiseDashboardData" class="district-wise-data">
    <p [style]="{'color': '#388585', 'font-size': '1.2rem', 'font-weight': 'bold'}">{{ districtWiseHeader }}</p>
    <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div *ngIf="pondDistrictWiseDashboarSchemedData.length > 0" class="field md:col-12 col-12">
            <div class="district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Pond/Tank Scheme Wise Total App'
                        }}</label>
                </div>
                <p-chart #barChart type="bar" [data]="pondDistrictWiseSchemeDataForGraph" [options]="optionsMIScheme" width="auto"
                    min-height="280px"></p-chart>
            </div>
        </div>

        <div *ngIf="subsidyDataForChart" class="field md:col-4 col-12">
            <div class="pie-district-border">
                <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Payment Done Stages'
                        }}</label>
                </div> -->
                <p-chart #pieChart type="pie" [data]="subsidyDataForChart" [options]="options2" width="250"
                    height="250"></p-chart>
            </div>
        </div>
        <div *ngIf="subsidyAreaDataForChart" class="field md:col-4 col-12">
            <div class="pie-district-border">
                <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Payment Amt'
                        }}</label>
                </div> -->
                <p-chart #pieChart type="pie" [data]="subsidyAreaDataForChart" [options]="options2" width="250"
                    height="250"></p-chart>
            </div>
        </div>

        <div *ngIf="Paymentstage" class="field md:col-4 col-12">
            <div class="pie-district-border">
                <!-- <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Payment Done CAO By Area'
                        }}</label>
                </div> -->
                <p-chart #pieChart type="pie" [data]="Paymentstage" [options]="options2" width="250"
                    height="250"></p-chart>
            </div>
        </div>
        <div class="field md:col-1 col-1">
        </div>
        </div>

        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
        <div *ngIf="casteDataForChart" class="field md:col-3 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Caste/Category Wise'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="casteDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <div *ngIf="yearWiseDataForChart" class="field md:col-6 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Year Wise Total Pond Area (acres)'
                        }}</label>
                </div>
                <p-chart #pieChart type="line" [data]="yearWiseDataForChart" [options]="optionsLine" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <div *ngIf="appTypeDataForChart" class="field md:col-3 col-12">
            <div class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Application Type'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="appTypeDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div>
        <!-- <div class="field md:col-3 col-12">
            <div *ngIf="componentDataForChart" class="pie-district-border">
                <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
                    <label [style]="{'color': '#388585', 'font-size': '1.0rem', 'font-weight': 'bold'}">{{ 'Component Wise'
                        }}</label>
                </div>
                <p-chart #pieChart type="pie" [data]="componentDataForChart" [options]="options2" width="225"
                    height="225"></p-chart>
            </div>
        </div> -->
    </div>
</div>

<div #miDrillDownData *ngIf="showMIUnderProcessDetails">
    <app-mi-consolidated-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-count-wise-report>
</div>

<div  *ngIf="showMITotalDetails">
    <app-mi-consolidated-total-app-report [finyear]="selectedYearForData"></app-mi-consolidated-total-app-report>
</div>

<div #pondDrillDownData *ngIf="showPondUnderProcessDetails">
    <app-pond-count-wise-report [finyear]="selectedYearForData"></app-pond-count-wise-report>
</div>

<div #miDrillDownData *ngIf="showMICompletedDetails">
    <app-mi-consolidated-completed-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-completed-count-wise-report>
</div>

<div #miDrillDownData *ngIf="showMIRejectedDetails">
    <app-mi-consolidated-rejected-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-rejected-count-wise-report>
</div>
<div #miDrillDownData *ngIf="showMIIncompletedDetails">
    <app-mi-consolidated-incompleted-count-wise-report [finyear]="selectedYearForData"></app-mi-consolidated-incompleted-count-wise-report>
</div>

<div #pondDrillDownData *ngIf="showPondCompletedDetails">
    <app-pond-complete-count-wise-report [finyear]="selectedYearForData"></app-pond-complete-count-wise-report>
</div>

<div #pondDrillDownData *ngIf="showPondRejectedDetails">
    <app-pond-rejected-count-wise-report [finyear]="selectedYearForData"></app-pond-rejected-count-wise-report>
</div>

<div #pondDrillDownData *ngIf="showPondIncompleteDetails">
    <app-pond-incomplete-count-wise-report [finyear]="selectedYearForData"></app-pond-incomplete-count-wise-report>
</div>
<!-- </div> -->